(function () {
    'use strict';

    angular.module('common')
        .service('UploadService', UploadService);

    UploadService.$inject = ['$http'];

    function UploadService($http) {
        const self = this;

        self.uploadArticulate       = uploadArticulate;
        self.uploadDocument         = uploadDocument;
        self.uploadFile             = uploadFile;
        self.uploadImage            = uploadImage;
        self.uploadInstitutionImage = uploadInstitutionImage;
        self.uploadVideo            = uploadVideo;

        return self;

        function uploadArticulate(file) {
            let s3Path = null;
            let id = null;
            return $http.get('getArticulateUploadUrl')
                .then(response => {
                    s3Path = response.data.s3_path;
                    id = response.data.articulate_id;
                    return uploadFileToUrl(response.data.url, file);
                })
                .then(() => $http.post(`articulateStory/${id}/onUploadSuccess`, {articulate_path: s3Path}));
        }

        function uploadDocument(file, params) {
            let uploadResponse;
            return upload(file, params, 'document')
                .then(response => {
                    uploadResponse = response;
                    const s3_key = response.data.s3_key;
                    if (s3_key) {
                        return onDocumentUploadSuccess(params.instance_id,{
                            s3_key,
                            filename: file.name,
                            ...params
                        });
                    } else {
                        return Promise.reject('Failed to upload file');
                    }
                })
                .then(() => uploadResponse);
        }

        function uploadFile(file, params) {
            return upload(file, params, 'file');
        }

        function uploadInstitutionImage(file) {
            return upload(file, {}, 'institutionImage');
        }

        function uploadImage(file, params) {
            return upload(file, params, 'image')
                .then(response => formatImageUploadResponse(response, file));
        }

        function uploadVideo(file, params) {
            return upload(file, params, 'video');
        }

        function upload(file, params, type) {
            let s3Path = '';
            return generateUploadUrl( { ...params, type, filename: file.name })
                .then(response => {
                    s3Path = response.data.s3_path;
                    return uploadFileToUrl(response.data.url, file);
                })
                .then(() => getS3Url(s3Path));
        }

        function generateUploadUrl(params) {
            return $http({
                method: 'GET',
                url: '/generateUploadUrl',
                params
            });
        }

        function uploadFileToUrl(uploadUrl, file) {
            return $http({
                method: 'PUT',
                url: uploadUrl,
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                data: file
            });
        }

        function getS3Url(s3_key) {
            return $http({
                method: 'GET',
                url: '/getS3Url',
                params: { s3_key }
            });
        }

        function onDocumentUploadSuccess(instance_id, params) {
            return $http({
                method: 'PUT',
                url: '/instances/' + instance_id + '/onDocumentUploadSuccess',
                params
            });
        }

        function formatImageUploadResponse(response, file) {
            if (response.status === 200) {
                const { prefix, extension } = splitS3Key(response.data.s3_key);
                return {
                    data: {
                        s3_prefix: prefix,
                        s3_extension: extension,
                        mime: file.type,
                        images: {
                            default: {
                                width: file.dimensions.width,
                                height: file.dimensions.height,
                                s3_suffix: ''
                            }
                        },
                        url: response.data.url
                    }
                };
            } else {
                console.warn(response);
                return Promise.reject('Failed to upload image');
            }
        }

        function splitS3Key(s3Key) {
            const dotIndex = s3Key.lastIndexOf('.');
            return {
                prefix: s3Key.substr(0, dotIndex),
                extension: s3Key.substr(dotIndex)
            };
        }
    }
})();
